import FileUploadStore from "data/FileUploadStore";
import Services from "lib/Services";
import BaseServices from "lib/BaseServices";

// combine a fields in-progress uploads with completed uploads.
export const buildFilesForField = (field, record_id, completedFiles = []) => {
    const inProgressFiles = FileUploadStore.getInProgressFilesByField(field, record_id);
    const allFiles = completedFiles.concat(inProgressFiles);
    allFiles.sort((a, b) => a._index <= b._index);
    return allFiles;
};

// add extra meta data to the file.
export const buildFileMeta = (fieldKey, recordId, org, entityKey, multiValued, file) => {
    const keyArr = entityKey.split("/");

    return {
        ...file,
        id: file.id,
        filename: file.filename,
        contentType: file.contentType,
        size: file.size,

        _data: file._data,

        _org: org,
        _impl: keyArr[0],
        _version: keyArr[1],
        _entity: keyArr[2],
        _field: fieldKey,
        _record_id: recordId,
        _index: file._index,
        _multiValued: multiValued,
    };
};

export const buildFileUrl = (file) => {
    if(file._status !== Hybrid.FileInfo.FILEUPLOADSTATES.COMPLETE) {
        return window.URL.createObjectURL(file._data);
    } else {
        const url = Services.url([
            file._org,
            file._impl,
            file._version,
            file._entity,
            file._record_id,
            "fields",
            file._field,
            "files",
            file.id,
            file.filename
        ]);

        // TODO: it might be better to make a get request and get the url from there.
        // that way, if we add the appropriate patterns to mock_config.js
        // this check below won't be necessary. the existing machinery will take care of
        // the url redirection/rewriting when an ajax request is made and there is a pattern in place.
        // however, the response data will be the raw file data which obviously can't be parsed
        // as JSON, thus resulting in an ajax error.
        if (BaseServices.__mocked) {
            return window.HybridConfig.mockRoot + url
                .split("/")
                .slice(window.HybridConfig.apiRoot
                             .split("/")
                             // filter out empty values (e.g.: '')
                             .filter(x => x)
                             .length)
                .join("/");
        }

        return url;
    }
};

// preview a file in new window. handles completed vs in-progress.
export const previewFile = (file) => {
    const url = buildFileUrl(file);
    if(file._status !== Hybrid.FileInfo.FILEUPLOADSTATES.COMPLETE) {
        window.open(url, "_blank")
            .addEventListener("load", () => window.URL.revokeObjectURL(url), {once: true});
    } else {
        window.open(url, "_blank");
    }
};



// WEBPACK FOOTER //
// ./app/data/selectors/fileUploads.js